<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ir_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd">
          <div class="weui-form-preview__item" slot="ir_acceptor">
            <label class="weui-form-preview__label">{{
              customLabel.ir_acceptor || "接收方"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_acceptor
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_prodcode">
            <label class="weui-form-preview__label">{{
              customLabel.ir_prodcode || "产品编号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{
              customLabel.pr_detail || "产品名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{
              customLabel.pr_orispeccode || "型号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_spec">
            <label class="weui-form-preview__label">{{
              customLabel.pr_spec || "规格"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_spec
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_qty">
            <label class="weui-form-preview__label">{{
              customLabel.ir_qty || "总数量"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.ir_qty }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_period">
            <label class="weui-form-preview__label">{{
              customLabel.ir_period || "周期"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_period
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_reject_ratio">
            <label class="weui-form-preview__label">{{
              customLabel.ir_reject_ratio || "不良率"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ir_reject_ratio }}%</span
            >
          </div>
          <div class="weui-form-preview__item" slot="ir_frequency">
            <label class="weui-form-preview__label">{{
              customLabel.ir_frequency || "事件发生次数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_frequency
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_exception_classes">
            <label class="weui-form-preview__label">{{
              customLabel.ir_exception_classes || "异常类别"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_exception_classes
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_custname">
            <label class="weui-form-preview__label">{{
              customLabel.ir_custname || "客户名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_complaint_type">
            <label class="weui-form-preview__label">{{
              customLabel.ir_complaint_type || "投诉类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_complaint_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_put_date">
            <label class="weui-form-preview__label">{{
              customLabel.ir_put_date || "提出日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_put_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_importance">
            <label class="weui-form-preview__label">{{
              customLabel.ir_importance || "重要程度"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_importance
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_vendname">
            <label class="weui-form-preview__label">{{
              customLabel.ir_vendname || "供应商名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_vendname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_finish_date">
            <label class="weui-form-preview__label">{{
              customLabel.ir_finish_date || "完成日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_finish_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_put_deparname">
            <label class="weui-form-preview__label">{{
              customLabel.ir_put_deparname || "发出单位"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_put_deparname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ir_duty_deparname">
            <label class="weui-form-preview__label">{{
              customLabel.ir_duty_deparname || "责任单位"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_duty_deparname
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="form-detail-preview_num">报告</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.ir_batchcode">
            <label class="weui-form-preview__label">{{
              customLabel.ir_batchcode || "受影响批次号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_batchcode
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.ir_leader || "1-D主导人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_leader
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_productioner">
            <label class="weui-form-preview__label">{{
              customLabel.ir_productioner || "生产部"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_productioner
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_qualityer">
            <label class="weui-form-preview__label">{{
              customLabel.ir_qualityer || "品质部"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_qualityer
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_engineer">
            <label class="weui-form-preview__label">{{
              customLabel.ir_engineer || "工程部"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_engineer
            }}</span>
          </div>

          <div class="weui-form-preview__item" v-if="form.main.ir_marketer">
            <label class="weui-form-preview__label">{{
              customLabel.ir_marketer || "市场部"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_marketer
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.ir_describe || "2-D问题描述"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_describe
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.ir_short_policy || "3-D临时对策"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_short_policy
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_sp_deparname">
            <label class="weui-form-preview__label">{{
              customLabel.ir_sp_deparname || "执行部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_sp_deparname
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_sp_dutyer">
            <label class="weui-form-preview__label">{{
              customLabel.ir_sp_dutyer || "负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_sp_dutyer
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_sp_date">
            <label class="weui-form-preview__label">{{
              customLabel.ir_sp_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_sp_date
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.ir_why || "4-D原因分析"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.ir_why }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.ir_why_deparname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.ir_why_deparname || "执行部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_why_deparname
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_why_dutyer">
            <label class="weui-form-preview__label">{{
              customLabel.ir_why_dutyer || "负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_why_dutyer
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_why_date">
            <label class="weui-form-preview__label">{{
              customLabel.ir_why_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_why_date
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.ir_long_policy || "5-D永久对策"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_long_policy
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_lp_deparname">
            <label class="weui-form-preview__label">{{
              customLabel.ir_lp_deparname || "执行部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_lp_deparname
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_lp_dutyer">
            <label class="weui-form-preview__label">{{
              customLabel.ir_lp_dutyer || "负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_lp_dutyer
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_lp_date">
            <label class="weui-form-preview__label">{{
              customLabel.ir_lp_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_lp_date
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.ir_effect || "6-D效果验证"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_effect
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.ir_effect_deparname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.ir_effect_deparname || "执行部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_effect_deparname
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.ir_effect_dutyer"
          >
            <label class="weui-form-preview__label">{{
              customLabel.ir_effect_dutyer || "负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_effect_dutyer
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_effect_date">
            <label class="weui-form-preview__label">{{
              customLabel.ir_effect_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_effect_date
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div
            class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.ir_prevent_policy || "7-D防止再发生对策"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_prevent_policy
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_pp_deparname">
            <label class="weui-form-preview__label">{{
              customLabel.ir_pp_deparname || "执行部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_pp_deparname
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_pp_dutyer">
            <label class="weui-form-preview__label">{{
              customLabel.ir_pp_dutyer || "负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_pp_dutyer
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_pp_date">
            <label class="weui-form-preview__label">{{
              customLabel.ir_pp_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_pp_date
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.ir_mqr || "8-D跟踪措施确认"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.ir_mqr }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.ir_mqr_deparname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.ir_mqr_deparname || "执行部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_mqr_deparname
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_mqr_dutyer">
            <label class="weui-form-preview__label">{{
              customLabel.ir_mqr_dutyer || "负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ir_mqr_dutyer
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ir_mqr_date">
            <label class="weui-form-preview__label">{{
              customLabel.ir_mqr_date || "日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ir_mqr_date
            }}</span>
          </div>
        </div>
      </div>
      
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.creatorName || "录入人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{
              customLabel.createTime || "录入日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.createTime
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/improvementReport/",
      caller: "ImprovementReport",
      xtype: "stock-improvementReport-formpanel",
    };
  },
};
</script>